import { render, staticRenderFns } from "./onebox-redirect-download-app.vue?vue&type=template&id=38970794&"
import script from "./onebox-redirect-download-app.vue?vue&type=script&lang=js&"
export * from "./onebox-redirect-download-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports